var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReuploadPermitted(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FF6A14"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.878 19.918H1.122c-.53 0-.98-.408-.98-.938V10c0-.51.43-.939.98-.939.551 0 .98.408.98.939v8.061h15.816V10c0-.51.429-.939.98-.939.551 0 .98.408.98.939v8.98c-.041.51-.47.938-1 .938z",
    transform: "translate(6 6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.49 4.143L10.714.367C10.347 0 9.734 0 9.347.367L5.53 4.143c-.184.184-.286.428-.286.694 0 .265.102.49.286.673.183.184.428.286.673.286.265 0 .51-.102.694-.286L8.98 3.45v9.694c0 .571.449 1.02 1.02 1.02s1.02-.449 1.02-1.02V3.408l2.102 2.102c.368.368.98.368 1.368 0 .183-.183.286-.428.286-.673 0-.266-.103-.51-.286-.694z",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReuploadPermitted);
export default __webpack_public_path__ + "static/media/reupload-permitted.598702e98fadff5913543d41ec34d841.svg";
export { ForwardRef as ReactComponent };